import React, { memo } from 'react';
export const HeroSection = () => {
  return <section className="w-full px-6 py-16 md:px-12 md:py-24 bg-gradient-to-b from-black via-zinc-950 to-zinc-900 relative" data-id="element-60">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(255,255,255,0.1),transparent)] opacity-50" data-id="element-61"></div>
      <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.02)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.02)_50%,rgba(255,255,255,0.02)_75%,transparent_75%,transparent)] bg-[length:200px_200px] opacity-10" data-id="element-62"></div>
      <div className="max-w-5xl mx-auto relative" data-id="element-63">
        <h1 className="text-4xl md:text-6xl font-serif font-light tracking-normal leading-tight mb-8" data-id="element-64">
          Digital <span className="text-white" data-id="element-65">Preservation</span> for the{' '}
          <span className="text-white/90" data-id="element-66">Discerning</span> Few
        </h1>
        <p className="text-xl md:text-2xl text-zinc-300 font-light tracking-wide mb-12 max-w-3xl" data-id="element-67">
          Immortalize your essence through our proprietary AI technology. Scion
          creates a living digital legacy from your memories, knowledge, and
          personality.
        </p>
        <div className="flex flex-col md:flex-row gap-6 mb-16" data-id="element-68">
          <button className="px-8 py-4 bg-white text-black hover:bg-zinc-100 rounded-sm transition-colors tracking-wider" data-id="element-69">
            Apply for Membership
          </button>
          <button className="px-8 py-4 border border-white/20 hover:border-white/30 rounded-sm transition-colors backdrop-blur-sm bg-black/30 tracking-wider" data-id="element-70">
            Learn Our Process
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center border-t border-white/10 pt-12" data-id="element-71">
          <div data-id="element-72">
            <p className="text-5xl font-serif font-light text-white mb-3" data-id="element-73">
              99.7%
            </p>
            <p className="text-zinc-400 tracking-wider" data-id="element-74">
              Personality Preservation Accuracy
            </p>
          </div>
          <div data-id="element-75">
            <p className="text-5xl font-serif font-light text-white mb-3" data-id="element-76">
              12+
            </p>
            <p className="text-zinc-400 tracking-wider" data-id="element-77">
              Proprietary AI Models
            </p>
          </div>
          <div data-id="element-78">
            <p className="text-5xl font-serif font-light text-white mb-3" data-id="element-79">∞</p>
            <p className="text-zinc-400 tracking-wider" data-id="element-80">
              Eternal Digital Legacy
            </p>
          </div>
        </div>
      </div>
    </section>;
};